import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
@Component({
  selector: 'app-pageEnrichments',
  templateUrl: './pageEnrichments.component.html',
  styleUrls: ['./pageEnrichments.component.css']
})
export class PageEnrichmentsComponent implements OnInit {

  @Input() data: any;
  showCate = "Enrichments";
  showSubCon = false;
  showSubdata = undefined;
  showEditOption = undefined;
  shouldToggle = false;
  toggleIcon = false;
  selectIcon = false;
  showFromEdit = false;
  editHide = true;
  checkItem = true;
  enrichmentData;
  bottomcat = [{ "name": "Download", "icon": "icon-Book-Download" }, { "name": "ScreenView", "icon": "icon-Presentation-V" }];
  mindMapRenderObject: any;

  constructor() { }

  ngOnInit() {


    this.mindMapRenderObject = {
      'currentPageDataObj': this.data.popupProps.currentPageDataObj,
      'showCloseButton': true,
      'componentState': this.data.popupProps.componentState,
      'hidePagesHeader': true
    };

  }

  clickBottomOptions(bCate, index) {
    this.showCate = bCate.name;
    this.showFromEdit = false;
    this.editHide = true;
    if (index == 0) this.data.callFromPageEnrichment('download');
    if (index == 1) this.data.callFromPageEnrichment('presentation');
  }

  minmapObjChanged(event) {
    this.data.popupProps.curComp.updateBookDataObj(event);

  }
  openCloseTab(evt, ind) {
    if (ind != this.showSubdata && this.showSubCon == true) {
      this.showSubCon = !this.showSubCon;
      this.toggleIcon = !this.toggleIcon;
    }
  }
  selectOption(evt, ind) {
    let clsList = evt.target.classList;
    if (clsList.value == 'icon-Rectangle') {
      clsList.remove('icon-Rectangle'); // To Remove
      clsList.add('icon-Checked'); // To toggle
    } else {
      clsList.remove('icon-Checked'); // To Remove
      clsList.add('icon-Rectangle'); // To toggle
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/pageEnrichments/pageEnrichments.component.ts